/**
 * Created with IntelliJ IDEA.
 * User: Noam/George Lucas
 * Date: 8/2014
 * Time: non of your business why do you want to know?
 *.
 */
define(function (require) {
    'use strict';

    var LE = require("app");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var CONST = require("const");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var NameUtility = require("utils/NameUtility");
    var DependencyService = require("src/components/dependency-service/controllers/DependencyService");
    var GalleryView = require("src/components/gallery-service/views/GalleryView");


    var GalleryController = Marionette.Controller.extend({

        //-------------------------------------------------------------------------
        // initialize
        //-------------------------------------------------------------------------

        initialize: function (options) {
            this.module = options.module;
            this.module.logger.info("initializing", "GalleryController:initialize");

            this._validateGalleryOptions(options);
            this.channel = options.channel;
            this.galleryCollection    = options.galleryCollection;
            this.galleryTitle         = options.galleryTitle;
            this.galleryDescription   = options.galleryDescription;
            this.galleryKP            = options.galleryKP || {};
            this.deleteErrorTitle     = options.deleteErrorTitle;
            this.deleteInUseErrorMessage   = options.deleteInUseErrorMessage;
            this.deleteConfirmTitle   = options.deleteConfirmTitle;
            this.deleteConfirmMessage = options.deleteConfirmMessage;
            this.allowDuplicate       = options.allowDuplicate;
            this.allowSetAsDefault      = options.allowSetAsDefault;
            this.duplicateAttribute =  options.duplicateAttribute;
            this.duplicateManually = options.duplicateManually;
            this.allowDelete =  _.has(options, "allowDelete") ? options.allowDelete : true;
            this.checkDependencies = _.has(options, "checkDependencies") ? options.checkDependencies : true;
            this.checkDependenciesLeaves = _.has(options, "checkDependenciesLeaves") ? options.checkDependenciesLeaves : true;
            this.editItemRoutePrefix = _.has(options, "editItemRoutePrefix") ? options.editItemRoutePrefix : "";

            //parameters initiated by calling function
            this.origSelectedItemId = null;
            this.selectedItemId = null;
            this._bindEvents();
            this._bindRequests();
        },

        _validateGalleryOptions: function(options){
            if (!options.galleryCollection ) {
                throw new Error("GalleryController: gallery collection is missing");
            }
            if (!_.isFunction(options.galleryCollection.getDefaultId)){
                throw new Error("GalleryController: gallery collection getDefaultId() function is missing");
            }
            if (!options.channel ) {
                throw new Error("GalleryController: gallery channel is missing");
            }
            var allowDelete =  _.has(options, "allowDelete") ? options.allowDelete : true;

            if (!options.galleryTitle || !options.galleryDescription ||
                (allowDelete && (!options.deleteErrorTitle || !options.deleteInUseErrorMessage ||
                    !options.deleteConfirmTitle || !options.deleteConfirmMessage))) {
                throw new Error("GalleryController: gallery texts are missing");
            }

            // validate that the model have all the functions
            var galleryModel = new options.galleryCollection.model();
            if (!_.isFunction(galleryModel.isDeletable)){
                throw new Error("GalleryController: gallery collection isDeletable() function is missing");
            }
            if (!_.isFunction(galleryModel.isEditable)){
                throw new Error("GalleryController: gallery collection isEditable() function is missing");
            }
            if (!_.isFunction(galleryModel.isDuplicatable)){
                throw new Error("GalleryController: gallery collection isDuplicatable() function is missing");
            }
            if (!_.isFunction(galleryModel.isViewable)){
                throw new Error("GalleryController: gallery collection isViewable() function is missing");
            }
        },

        //-------------------------------------------------------------------------

        _bindEvents:function(){
            //routing events
            this.listenTo(this.channel.vent, "GalleryView:cancel",                  this._onCancel);
            this.listenTo(this.channel.vent, "GalleryView:closeWindow",             this._onCancel);
            this.listenTo(this.channel.vent, "GalleryView:back",                    this._onBack);
            this.listenTo(this.channel.vent, "GalleryView:next",                    this._onNext);
            this.listenTo(this.channel.vent, "GalleryView:done",                    this._onDone);

            //controlling events
            this.listenTo(this.channel.vent, "GalleryView:select",                  this._onSelect);
            this.listenTo(this.channel.vent, "GalleryView:create",                  this._onCreate);
            this.listenTo(this.channel.vent, "GalleryView:addApiBasedWindow",       this._onCreate);
            this.listenTo(this.channel.vent, "GalleryView:edit",                    this._onEdit);
            this.listenTo(this.channel.vent, "GalleryView:view",                    this._onView);
            this.listenTo(this.channel.vent, "GalleryView:delete",                  this._onDelete);
            this.listenTo(this.channel.vent, "GalleryView:duplicate",               this._onDuplicate);
            this.listenTo(this.channel.vent, "GalleryView:setAsDefault",            this._setAsDefault);

            this.listenTo(this.channel.vent, "GalleryView:dependencyClick", this._onDependencyClick);

            this.listenTo(this.galleryCollection, "remove", this._onItemRemoved);

        },

        _bindRequests:function(){

        },

        _onCancel: function(){
            this.channel.trigger("gallery:cancel");
        },
        _onBack: function(){
            this.channel.trigger("gallery:back");
        },
        _onNext: function(){
            this.channel.trigger("gallery:next", this.selectedItemId);
        },
        _onDone: function(){
            this.channel.trigger("gallery:done", this.selectedItemId);
        },
        _onSelect: function(selectedItemId){
            this.selectedItemId = selectedItemId;
        },

        _onCreate: function() {
            this._routeToItemEdit(CONST.ROUTING.NEW_ITEM_ID);
        },
        _onEdit: function(itemId) {
            this._routeToItemEdit(itemId);
        },
        _onView: function(itemId) {
            //the routed Model has only view permissions thus
            // this function does not really differ for now from the edit function
            this._routeToItemEdit(itemId);
        },
        _routeToItemEdit: function(id) {
            var currentRoute = LE.context.get("navigationCurrent.route");

            if (_.contains(currentRoute, "/select/")) {
                currentRoute = currentRoute.split("/select/")[0];
            }

            if (!_.isEmpty(this.editItemRoutePrefix)) {
                currentRoute = currentRoute + "/" + this.editItemRoutePrefix;
            }

            this.lastEditItemRoute = currentRoute + "/" + id;
            this.module.router.navigate(this.lastEditItemRoute);
        },
        _onDelete: function(itemId){
            this.module.notifier.showConfirm({
                title:   this.deleteConfirmTitle,
                content: this.deleteConfirmMessage,
                objectAction: {
                    text: LE.translator.translate("LEFramework.global.captions.yes"),
                    callback:_.bind(this._doDeleteGalleryItem, this)
                }
            });
        },

        _doDeleteGalleryItem: function(){
            this.module.logger.info("Deleting gallery item", "GalleryController:_doDeleteGalleryItem");
            this.showLoader();

            this.itemModel = this.galleryCollection.get(this.selectedItemId);

            this.itemModel.destroy({
                success: _.bind(this._onDeleteSuccess, this),
                error: _.bind(this._onDeleteFailed, this),
                wait: true
            });
        },

        _onDeleteSuccess: function(){
            this.module.logger.info("Gallery Item deleted successfully", "GalleryController:_onDeleteSuccess");
            this.closeLoader();
        },

        _onDeleteFailed: function(collection, resp, options){
            this.module.logger.info("Failed to delete target gallery item", "GalleryController:_onDeleteFailed");
            this.closeLoader();
            var errorMsg = "";
            if (resp && _.has(resp, "responseError") && _.has(resp.responseError, "message")) {
                errorMsg = resp.responseError.message;
            }

            if (resp && _.has(resp,"responseError")){
                if (resp.responseError.internalCode === ErrorCodes.dependencyConflict || resp.responseError.code === ErrorCodes.dependencyConflictBackend) {
                    errorMsg = this.deleteInUseErrorMessage;
                }
            }
            this.module.notifier.showError({
                title:   this.deleteErrorTitle,
                content: errorMsg,
                "objectAction":{
                    text: LE.translator.translate("LEFramework.global.captions.ok"),
                    callback: function(){}
                },
                removeAditionalButton: true
            });
        },

        _onDuplicate: function(){
            this.module.logger.info("Duplicating gallery item", "GalleryController:_onDuplicate");

            if (this.duplicateManually) {
                this.channel.trigger("gallery:duplicate", this.selectedItemId);
                return;
            }

            this.selectedModel = this.galleryCollection.get(this.selectedItemId);
            this.duplicatedModel = new  this.galleryCollection.model();

            if(_.isObject(this.duplicatedModel)){   //todo wattt is this test for? we should test for collection.get returing a result ..
                this.showLoader();
                var duplicateData = {
                    "setAttributes": {}
                };

                var duplicateModelName = {
                    "name": NameUtility.duplicateName(this.galleryCollection, this.selectedModel.get("name"))
                };
                var entityPath = this.galleryCollection.resource.entityPathForDuplicate;
                if (entityPath) {
                    duplicateData.setAttributes[entityPath] = duplicateModelName;

                    this.duplicatedModel.duplicate(
                        this.selectedModel,
                        {
                            data: duplicateData,
                            success: _.bind(this._onDuplicateSuccess, this),
                            error: _.bind(this._onDuplicateError, this),
                            wait: true
                        },
                        this.selectedModel.collection);
                } else {
                    this.closeLoader();
                    this.module.logger.error("Duplicating gallery item", "GalleryController:_onDuplicate");
                    throw new Error ("Duplicating gallery item - entityPathForDuplicate is missing on resource");
                }
            }
        },

        _onDuplicateSuccess: function() {
            this.module.logger.info("Gallery Item duplicated successfully", "GalleryController:_onDuplicateSuccess");
            this.galleryCollection.add(this.duplicatedModel);
            this.closeLoader();
        },

        _onDuplicateError: function() {
            this.module.logger.error("Failed to duplicate target gallery item", "GalleryController:_onDuplicateFailed");
            LE.notifier.showError(LE.translator.translate("gallery.duplicate." + this.duplicatedModel.getSegmentTypeKey() + ".error"));
            this.closeLoader();
        },

        _setAsDefault: function(){
            this.module.logger.info("Set a gallery item as default", "GalleryController:_setAsDefault");
            this.selectedModel = this.galleryCollection.get(this.selectedItemId);
            if (this.selectedModel.canSetUserDefault()) {
                this.showLoader();
                this.selectedModel.setUserDefault();
                this.selectedModel.save(null, {
                    success: _.bind(this._onSetAsDefaultSuccess,this),
                    error: _.bind(this._onSetAsDefaultError,this)
                });
            }
        },

        _onSetAsDefaultSuccess: function(){
            this.module.logger.info("Gallery Item model has been saved successfully", "GalleryController:_onSetAsDefaultSuccess");

            this.galleryCollection.fetch({
                success: _.bind(this._onGalleryCollectionFetchSuccess,this),
                error: _.bind(this._onGalleryCollectionFetchError,this),
                reset: true
            });
        },

        _onGalleryCollectionFetchSuccess: function(collection){
            //when set as default is successful, the corresponding item id should be selected
            this.galleryOptions.selectedItemId = this.selectedItemId;
            this.galleryOptions.skipOrigSelectedItemId = true;
            this.showGallery(this.galleryOptions);
            this.module.logger.info("Gallery collection has been fetched successfully", "GalleryController:_onGalleryCollectionFetchSuccess");
            this.closeLoader();
        },

        _onGalleryCollectionFetchError: function(){
            this.module.logger.info("Gallery collection has failed to fetch", "GalleryController:_onGalleryCollectionFetchError");
            this.closeLoader();
        },

        _onSetAsDefaultError: function(){
            this.module.logger.error("Failed to set a gallery item as default", "GalleryController:_onSetAsDefaultError");
            this.closeLoader();
        },

        _loadDependencies: function() {
            if (this.checkDependencies){
                DependencyService.getDependencies(this.galleryCollection, {
                    checkDependenciesLeaves: this.checkDependenciesLeaves,
                    success: _.bind(this._onDependenciesFetchSuccess, this),
                    error: _.bind(this._onDependenciesFetchError, this)
                });
            }
        },

        _onDependenciesFetchError: function(collection, response, options) {
            this.module.logger.debug ("dependencies fetched error","GoalsController:_onDependenciesFetchError", response);
        },

        _onDependenciesFetchSuccess: function(collection, response, options) {
            if(!this.insideView) {
                return;  //in case the page was closed
            }

            var dependenciesArr = [];
            var contextEntity = this.galleryOptions.contextEntity || {};
            var supportedDependeeTypes = contextEntity.supportedDependeeTypes || ["LECampaignObject"];

            collection.each(function(dependencyModel){
                var itemId = dependencyModel.get("id");
                var itemDependenciesCollection = dependencyModel.get("dependencies");
                var itemDependenciesMap = {};
                var itemType = dependencyModel.get("type").trim();


                itemDependenciesCollection.each(_.bind(function(dependencyModel){
                    var dependencyType = dependencyModel.get("type");
                    if (_.contains(supportedDependeeTypes, dependencyType) && String(dependencyModel.id) !== String(contextEntity.id)) { // if the dependee type is one of the supported/requested type and it's not the context entity id
                        if (this.module.getDataManager() && _.isFunction(this.module.getDataManager().getDependencyData)) { // make sure we can get the dependencyData before we are trying doing that
                            var dependencyData = this.module.getDataManager().getDependencyData(dependencyModel);
                            if (dependencyData) {
                                itemDependenciesMap[dependencyType] = itemDependenciesMap[dependencyType] || [];
                                itemDependenciesMap[dependencyType].push(this.module.getDataManager().getDependencyData(dependencyModel));
                            }
                        }
                    }
                }, this));

                if (!_.isEmpty(itemDependenciesMap)) {
                    dependenciesArr.push({
                        itemId: itemId,
                        config: {
                            title: LE.translator.translate("LEFramework.gallery.dependency.indicator.title." + itemType),
                            dependenciesMap: itemDependenciesMap
                        }
                    });
                }

            }, this);

            this.insideView.updateDependencies(dependenciesArr);
        },

        _onDependencyClick: function(url){
            this.module.router.navigate(url);
        },

        _renderGallery: function(){
            var options = {
                module: this.module,
                stepIndicatorOptions:       this.stepIndicatorOptions,
                buttonOptions:              this.buttonOptions,
                selectedItemId:             this.selectedItemId,
                origSelectedItemId:         this.origSelectedItemId,
                galleryCollection:          this.galleryCollection,
                channel:                    this.channel,
                allowDuplicate:             this.allowDuplicate,
                allowSetAsDefault:          this.allowSetAsDefault,
                allowApiBasedWindow:        this.allowApiBasedWindow,
                engagementSourceId:         this.engagementSourceId,
                galleryFilters:             this.galleryFilters,
                collectionMap:              this.collectionMap,
                showDependencyTypeTitle:    this.showDependencyTypeTitle
            };
            if (this.maxItemsToDisplay) {
                options.maxItemsToDisplay = this.maxItemsToDisplay;
            }
            this.insideView = new GalleryView(options);
            this.pageView.setInsideView(this.insideView);
            this.listenTo(this.insideView,"close",this._onInsideViewClose);

            this.closeLoader();

            this._loadDependencies();
        },

        _onInsideViewClose: function(){
            //clean stuff if needed
            if (this.insideView) {
                this.stopListening(this.insideView);
            }
            this.insideView = null;
        },


        _initPageView: function(page){
            this.pageView = page;
            this.pageView.setTitle(this.galleryTitle);
            this.pageView.setDescription(this.galleryDescription);
            this.pageView.setActionStrip(true);
            this.pageView.setKnowledgePack(this.galleryKP);
            this.pageView.setDependency({}); //no dependency here
        },

        /**
         * Validate selected Item on gallery if it does not exist choose a different one
         *
         * We select the itemSelected on the gallery if nothing is selected we
         * check if there is a default selection.
         * If there is no default select the first Item
         * @private
         */
        _ensureSelection: function(){
            if (this.galleryCollection.size() > 0 ) {
                //strongly suggest a working selection if there is no selection
                if (_.isNull(this.selectedItemId) || _.isUndefined(this.selectedItemId) || !this.galleryCollection.get(this.selectedItemId)) {
                    var defaultItemId =  this.galleryCollection.getDefaultId();
                    //if no selection and we have default select the default else select the first one
                    this.selectedItemId =  defaultItemId? defaultItemId : this.galleryCollection.at(0).id;
                }
            }
        },

        // after deletion of the selected element the gallery should automatically select something
        _onItemRemoved: function(model, collection, options){
            if (this.selectedItemId === model.id) {
                this.selectedItemId = this.origSelectedItemId;
                this._ensureSelection();
                if (this.insideView) {
                    this.insideView.selectItemOnGallery(this.selectedItemId);
                }

            }
        },
        ensureSelectionAndLoadGallery: function(galleryCollection, filters){
            this.galleryCollection = galleryCollection;
            this._ensureSelection();

            if (this.insideView) {
                this.stopListening(this.insideView);
                this.insideView.close();
            }
            this.galleryFilters = filters;
            this._renderGallery();
        },

        showGallery: function(options) {
            this.galleryOptions = options;
            if (_.isEmpty(options.buttonOptions)){
                throw "GalleryController: buttons are missing";
            }

            if (_.isEmpty(options.page)){
                throw "GalleryController: page  is missing";
            }
            this._initPageView(options.page);

            var previousRoute = LE.context.get("previousApplicationRoute.route");
            if (this.lastEditItemRoute && this.lastEditItemRoute === previousRoute){
                //we came from galleryItem Edit do not touch the selection
            } else if (!this.galleryOptions.skipOrigSelectedItemId){
                //if we come from bookmark or campaigns - reset selected Items
                this.origSelectedItemId = this.selectedItemId = options.selectedItemId;
            }

            this.showLoader();
            this.galleryCollection = options.collection || this.galleryCollection;
            this._ensureSelection();

            if (this.insideView) {
                this.stopListening(this.insideView);
            }

            this.engagementSourceId = options.engagementSourceId;

            this.stepIndicatorOptions = options.stepIndicatorOptions;
            this.buttonOptions = options.buttonOptions;
            this.allowSetAsDefault = !!options.allowSetAsDefault;
            this.allowApiBasedWindow = !!options.allowApiBasedWindow;
            this.showDependencyTypeTitle = !!options.showDependencyTypeTitle;
            this.maxItemsToDisplay = options.maxItemsToDisplay;
            this.collectionMap = options.collectionMap || {};
            this.galleryFilters = options.galleryFilters || [];

            this._renderGallery();
        },
        getView: function() {
            return this.pageView;
        },
        showLoader: function(){
            this.pageView.showLoader();
        },
        updateSelectedItemId: function(id) {
            this.selectedItemId = id;
        },
        closeLoader: function(){
            this.pageView.closeLoader();
        }

    });

    return  GalleryController;
});
